import { render, staticRenderFns } from "./teamRYtable.vue?vue&type=template&id=2ad9b81c&scoped=true"
import script from "./teamRYtable.vue?vue&type=script&lang=js"
export * from "./teamRYtable.vue?vue&type=script&lang=js"
import style0 from "./teamRYtable.vue?vue&type=style&index=0&id=2ad9b81c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad9b81c",
  null
  
)

export default component.exports